import React from 'react';
import BookingPage from './BookingPage';

const Home = () => {
  return (
    <div className="home-page">
      <section id="booking" className="booking-section">
        <div className="container">
          <BookingPage />
        </div>
      </section>
    </div>
  );
};

export default Home;
